function PreviewModal({ iframeSrc, videoSrc, onClose }) {
  if (!iframeSrc && !videoSrc) return null;

  return (
    <div className="iframe-overlay" onClick={onClose}>
      <div className="iframe-window" onClick={(e) => e.stopPropagation()}>
        <header className="iframe-titlebar">
          <span className="iframe-url">
            {iframeSrc || 'CroakQuest Trailer'}
          </span>
          <button
            type="button"
            className="window-close"
            onClick={onClose}
            aria-label="Close preview"
          >
            x
          </button>
        </header>

        {iframeSrc && (
          <iframe
            src={iframeSrc}
            title="Website preview"
            className="iframe-content"
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
          />
        )}

        {videoSrc && (
          <video
            src={videoSrc}
            className="iframe-content"
            controls
            autoPlay
            style={{ background: '#000' }}
          />
        )}
      </div>
    </div>
  );
}

export default PreviewModal;
